import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import PublicRoundedIcon from '@mui/icons-material/PublicRounded'
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded'
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded'
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded'
import FolderSharedRoundedIcon from '@mui/icons-material/FolderSharedRounded'
import LocalFloristRoundedIcon from '@mui/icons-material/LocalFloristRounded'
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded'
import WorkOutlineRoundedIcon from '@mui/icons-material/WorkOutlineRounded'
// GE-CAPPS — Apps custom utilisateur (specs construites via le MCP Claude)
import AppsRoundedIcon from '@mui/icons-material/AppsRounded'
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded'
import {
  Box,
  Button,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  Typography,
} from '@mui/material'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// LAP-733 (GE022) — translation keys for option labels.
// `route` paths and `in` aspect codes are kept untranslated on purpose:
// they are matched server/client-side and must not change with the locale.
const options = [
  { tKey: 'menu.home', route: '/' }, //0
  { tKey: 'menu.myAccounts', route: '/MesComptes', in: 'Finance' }, //1
  { tKey: 'menu.categorisation', route: '/categorisation', in: 'Finance' }, //2
  { tKey: 'menu.financialDashboard', route: '/Fistatement', in: 'Finance' }, //3
  { tKey: 'menu.financialDashboard', route: '/catalogue', in: 'Finance' }, //4
  { tKey: 'menu.myFinances', route: '/dashboard-detail/D', in: 'Finance' }, //5
  { tKey: 'menu.myFinances', route: '/dashboard-detail/R', in: 'Finance' }, //6
  { tKey: 'menu.myFinances', route: '/dashboard-detail/moncashflow', in: 'Finance' }, //7
  { tKey: 'menu.myFinances', route: '/dashboard-detail/mesactifs', in: 'Finance' }, //8
  { tKey: 'menu.myFinances', route: '/dashboard-detail/mespassifs', in: 'Finance' }, //9
  { tKey: 'menu.operationsManagement', route: '/gestionoperations', in: 'Finance' }, //10
  { tKey: 'menu.myObjectives', route: '/mesobjectifs', in: 'General' }, //11
  { tKey: 'menu.myRealEstate', route: '/domicile/monimmobilier', in: 'Domicile' }, //12
  { tKey: 'menu.myVehicles', route: '/domicile/mesvehicules', in: 'Domicile' }, //13
  { tKey: 'menu.myRealEstate', route: '/domicile/monimmobilier/monbien', in: 'Domicile' }, //14
  { tKey: 'menu.myVehicles', route: '/domicile/vehicule', in: 'Domicile' }, //15
  { tKey: 'menu.myVehicles', route: '/domicile/historiquekm/vehicule', in: 'Domicile' }, //16
  { tKey: 'menu.myVehicles', route: '/domicile/historiquevalo/vehicule', in: 'Domicile' }, //17
  { tKey: 'menu.myVehicles', route: '/domicile/financement/vehicule', in: 'Domicile' }, //18
  { tKey: 'menu.myVehicles', route: '/domicile/detaildepense/vehicule', in: 'Domicile' }, //19
  { tKey: 'menu.myDocuments', route: '/Administrative/documents', in: 'administrative' }, //20
  { tKey: 'menu.myContacts', route: '/MesContacts', in: 'Social' }, //21
  { tKey: 'menu.socialDashboard', route: '/social-dashboard', in: 'Social' }, //22 — LAP-646
  { tKey: 'menu.myCalendar', route: '/MonCalendrier', in: 'Time' }, //23
  { tKey: 'menu.myBucketList', route: '/BuckList', in: 'Personal' }, //24
  { tKey: 'menu.home', route: '/search' }, //25 (Search Results)
  { tKey: 'menu.myRealEstate', route: '/domicile/immovalue/immobilier/', in: 'Domicile' }, //26
  { tKey: 'menu.myRealEstate', route: '/domicile/financement/immobilier/', in: 'Domicile' }, //27
  { tKey: 'menu.myRealEstate', route: '/domicile/detaildepense/immobilier/', in: 'Domicile' }, //28
  { tKey: 'menu.ecoDashboard', route: '/Dashboard', in: 'Terre' }, //29
  { tKey: 'menu.myPlants', route: '/Mesplantes', in: 'Garden' }, //30
  { tKey: 'menu.maintenancePlan', route: '/domicile/entretien', in: 'Domicile' }, //31
  { tKey: 'menu.myProPath', route: '/parcourspro', in: 'Pro' }, //32
  { tKey: 'menu.myTodos', route: '/todos', in: 'MesToDo' }, //33
  { tKey: 'menu.myRecipes', route: '/recette', in: 'Personnal' }, //34
  { tKey: 'menu.myRecipes', route: '/recette-category', in: 'Personnal' }, //35
  { tKey: 'menu.myMenu', route: '/Menu', in: 'Personnal' }, //36
  { tKey: 'menu.myBudget', route: '/Monbudget', in: 'Finance' }, //37
  { tKey: 'menu.myWealthBalance', route: '/MonPatrimoine', in: 'Finance' }, //38
  { tKey: 'menu.timeDashboard', route: '/syntheseTemps', in: 'General' }, //39
  { tKey: 'menu.professionalOpportunities', route: '/Opportunities', in: 'Pro' }, //40
  { tKey: 'menu.professionalSummary', route: '/professionnelle', in: 'Pro' }, //41
  { tKey: 'menu.workTime', route: '/tempsdetravail', in: 'Pro' }, //42
  { tKey: 'menu.myInvestments', route: '/investments', in: 'Finance' }, //43
  { tKey: 'menu.myRoadmap', route: '/roadmap', in: 'General' }, //44
  { tKey: 'menu.lifeResume', route: '/life-resume', in: 'General' }, //45
  { tKey: 'menu.healthModule', route: '/sante', in: 'Health' }, //46 — Module Santé
  { tKey: 'menu.performanceModule', route: '/performance', in: 'Health' }, //47 — Life Performance
  { tKey: 'menu.myContracts', route: '/contrats', in: 'Domicile' }, //48 — Module Contrats
  { tKey: 'menu.myInbox', route: '/inbox', in: 'Social' }, //49 — Boîte de réception
  { tKey: 'menu.taxCenter', route: '/tax-center', in: 'Finance' }, //50 — Tax Intelligence Engine
]

// LAP-733 (GE022) — menu groups and items now hold translation keys.
// `to` paths must remain untranslated.
// `icon` provides a clean visual hierarchy in the redesigned launcher.
const menu_main = [
  {
    titleKey: 'menu.home',
    to: '/',
    icon: HomeRoundedIcon,
    standalone: true,
  },
]
const menu = [
  {
    titleKey: 'menu.myFootprint',
    icon: PublicRoundedIcon,
    items: [
      { titleKey: 'menu.ecoDashboard', to: '/Dashboard' },
    ],
  },
  {
    titleKey: 'menu.myFinances',
    icon: AccountBalanceWalletRoundedIcon,
    items: [
      { titleKey: 'menu.myWealthBalance', to: '/MonPatrimoine', alwaysShow: true },
      { titleKey: 'menu.myAccounts', to: '/MesComptes' },
      { titleKey: 'menu.categorisation', to: '/categorisation' },
      { titleKey: 'menu.financialDashboard', to: '/Fistatement' },
      { titleKey: 'menu.operationsManagement', to: '/gestionoperations' },
      { titleKey: 'menu.myBudget', to: '/Monbudget' },
      { titleKey: 'menu.myInvestments', to: '/investments' },
      // Tax Intelligence Engine — position fiscale, opportunités, échéances.
      { titleKey: 'menu.taxCenter', to: '/tax-center', alwaysShow: true },
    ],
  },
  {
    titleKey: 'menu.myTime',
    icon: ScheduleRoundedIcon,
    items: [
      // Dashboard temps — synthèse du temps (TM002)
      { titleKey: 'menu.timeDashboard', to: '/syntheseTemps', alwaysShow: true },
      { titleKey: 'menu.myObjectives', to: '/mesobjectifs' },
      { titleKey: 'menu.myCalendar', to: '/MonCalendrier' },
      { titleKey: 'menu.myBucketList', to: '/BucketList' },
      { titleKey: 'menu.myTodos', to: '/todos' },
      { titleKey: 'menu.myRoadmap', to: '/roadmap', alwaysShow: true },
      { titleKey: 'menu.lifeResume', to: '/life-resume', alwaysShow: true },
    ],
  },
  {
    titleKey: 'menu.myHome',
    icon: ApartmentRoundedIcon,
    items: [
      { titleKey: 'menu.myRealEstate', to: '/domicile/monimmobilier' },
      { titleKey: 'menu.myVehicles', to: '/domicile/mesvehicules' },
      { titleKey: 'menu.maintenancePlan', to: '/domicile/entretien' },
    ],
  },
  {
    titleKey: 'menu.myAdmin',
    icon: FolderSharedRoundedIcon,
    items: [
      { titleKey: 'menu.myDocuments', to: '/documents' },
      // Module Contrats — contrats du foyer + interprétation IA des factures
      { titleKey: 'menu.myContracts', to: '/contrats', alwaysShow: true },
    ],
  },
  {
    titleKey: 'menu.myPersonalLife',
    icon: LocalFloristRoundedIcon,
    items: [
      { titleKey: 'menu.myPlants', to: '/Mesplantes' },
      { titleKey: 'menu.myRecipes', to: '/recette' },
      { titleKey: 'menu.myMenu', to: '/Menu' },
      { titleKey: 'menu.myShoppingList', to: '/shopping' },
      // Module Santé — copilote santé personnel (CDC « LIFE APP — Module Santé »)
      { titleKey: 'menu.healthModule', to: '/sante', alwaysShow: true },
      { titleKey: 'menu.performanceModule', to: '/performance', alwaysShow: true },
    ],
  },
  {
    titleKey: 'menu.myRelations',
    icon: GroupsRoundedIcon,
    items: [
      { titleKey: 'menu.myContacts', to: '/MesContacts' },
      // LAP-646 — Social Dashboard
      { titleKey: 'menu.socialDashboard', to: '/social-dashboard' },
      // Boîte de réception — messagerie interne
      { titleKey: 'menu.myInbox', to: '/inbox', alwaysShow: true },
    ],
  },
  {
    titleKey: 'menu.myCareer',
    icon: WorkOutlineRoundedIcon,
    items: [
      { titleKey: 'menu.myProPath', to: '/parcourspro' },
      { titleKey: 'menu.professionalOpportunities', to: '/opportunities' },
      { titleKey: 'menu.professionalSummary', to: '/professionnelle' },
      { titleKey: 'menu.workTime', to: '/tempsdetravail' },
    ],
  },
  {
    // GE-CAPPS — apps custom construites avec Claude (connecteur Life MCP)
    titleKey: 'menu.myApps',
    icon: AppsRoundedIcon,
    items: [
      { titleKey: 'menu.myApps', to: '/apps', alwaysShow: true },
    ],
  },
]

// LAP-733 fix: previous version emitted `title: group.title` but the source
// list now uses `titleKey`. That broke section labels in the launcher menu.
// We now preserve the full group (including `titleKey` and `icon`) and only
// swap in the filtered items.
function filterStaticListByAppList(appList, staticList) {
  const appLinks = (appList || []).map((app) => app.Lien)

  return staticList
    .map((group) => {
      if (!group.items) return null

      const matchedItems = group.items.filter(
        (item) => appLinks.includes(item.to) || item.alwaysShow === true
      )

      if (matchedItems.length === 0) return null
      return { ...group, items: matchedItems }
    })
    .filter((group) => group !== null)
}

/**
 * SectionGroup — one titled section in the launcher (e.g. "Mes finances").
 * Renders an icon + translated header, then its items as a tidy list.
 */
const SectionGroup = ({ group, onItemClick, currentPath }) => {
  const { t } = useTranslation('layout')
  const Icon = group.icon
  // Backwards-compat: support `title` literal in case some caller still
  // passes a non-translated label.
  const label = group.titleKey ? t(group.titleKey) : group.title

  return (
    <Box sx={{ px: 1, py: 0.5 }}>
      <ListSubheader
        disableSticky
        component="div"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          background: 'transparent',
          color: 'text.primary',
          fontSize: '0.82rem',
          fontWeight: 800,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          lineHeight: 1.5,
          py: 1.25,
          px: 1.25,
        }}
      >
        {Icon ? <Icon sx={{ fontSize: 18, opacity: 0.9 }} /> : null}
        {label}
      </ListSubheader>
      <List dense disablePadding>
        {group.items.map((item, idx) => {
          const itemLabel = item.titleKey ? t(item.titleKey) : item.title
          const selected = currentPath === item.to
          return (
            <ListItemButton
              key={idx}
              component={Link}
              to={item.to}
              onClick={onItemClick}
              selected={selected}
              sx={{
                borderRadius: 1.5,
                mx: 0.5,
                my: 0.25,
                py: 0.6,
                px: 1.25,
                color: 'text.primary',
                textDecoration: 'none',
                '&.Mui-selected': {
                  bgcolor: 'action.selected',
                  fontWeight: 600,
                },
                '&:hover': {
                  bgcolor: 'action.hover',
                },
              }}
            >
              <ListItemText
                primary={itemLabel}
                primaryTypographyProps={{
                  fontSize: '0.875rem',
                  fontWeight: selected ? 600 : 400,
                }}
              />
            </ListItemButton>
          )
        })}
      </List>
    </Box>
  )
}

/**
 * StandaloneItem — one top-level item without a section (e.g. "Page d'accueil").
 */
const StandaloneItem = ({ item, onItemClick, currentPath }) => {
  const { t } = useTranslation('layout')
  const Icon = item.icon
  const label = item.titleKey ? t(item.titleKey) : item.title
  const selected = currentPath === item.to
  return (
    <ListItemButton
      component={Link}
      to={item.to}
      onClick={onItemClick}
      selected={selected}
      sx={{
        borderRadius: 1.5,
        mx: 1,
        my: 0.5,
        py: 0.85,
        px: 1.5,
        color: 'text.primary',
        textDecoration: 'none',
        '&.Mui-selected': {
          bgcolor: 'action.selected',
        },
        '&:hover': {
          bgcolor: 'action.hover',
        },
      }}
    >
      {Icon ? (
        <ListItemIcon sx={{ minWidth: 32, color: 'primary.main' }}>
          <Icon sx={{ fontSize: 20 }} />
        </ListItemIcon>
      ) : null}
      <ListItemText
        primary={label}
        primaryTypographyProps={{
          fontSize: '0.95rem',
          fontWeight: selected ? 600 : 500,
        }}
      />
    </ListItemButton>
  )
}

export default function SimpleListMenu() {
  const { t } = useTranslation('layout')
  const location = useLocation()
  const siteUser = useSelector((store) => store.user)
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [appMenu, setAppMenu] = React.useState([])

  // Recompute the visible launcher whenever the user's app list changes.
  React.useEffect(() => {
    const userApps = siteUser?.user?.user_apps
    const filtered = filterStaticListByAppList(userApps, menu)
    setAppMenu(filtered)
  }, [siteUser?.user?.user_apps])

  React.useEffect(() => {
    const pathname = location.pathname.slice(1).toLowerCase()

    if (pathname === '') {
      setSelectedIndex(0)
    } else if (pathname === 'mescomptes') {
      setSelectedIndex(1)
    } else if (pathname === 'categorisation') {
      setSelectedIndex(2)
    } else if (pathname === 'fistatement') {
      setSelectedIndex(3)
    } else if (pathname === 'catalogue') {
      setSelectedIndex(4)
    } else if (pathname === 'dashboard-detail/d') {
      setSelectedIndex(5)
    } else if (pathname === 'dashboard-detail/r') {
      setSelectedIndex(6)
    } else if (pathname === 'dashboard-detail/moncashflow') {
      setSelectedIndex(7)
    } else if (pathname === 'dashboard-detail/mesactifs') {
      setSelectedIndex(8)
    } else if (pathname === 'dashboard-detail/mespassifs') {
      setSelectedIndex(9)
    } else if (pathname === 'gestionoperations') {
      setSelectedIndex(10)
    } else if (pathname === 'mesobjectifs') {
      setSelectedIndex(11)
    } else if (pathname === 'domicile/monimmobilier') {
      setSelectedIndex(12)
    } else if (pathname === 'domicile/mesvehicules') {
      setSelectedIndex(13)
    } else if (pathname.startsWith('domicile/monimmobilier/monbien')) {
      setSelectedIndex(14)
    } else if (pathname.startsWith('domicile/vehicule')) {
      setSelectedIndex(15)
    } else if (pathname.startsWith('domicile/historiquekm/vehicule')) {
      setSelectedIndex(16)
    } else if (pathname.startsWith('domicile/historiquevalo/vehicule')) {
      setSelectedIndex(17)
    } else if (pathname.startsWith('domicile/financement/vehicule')) {
      setSelectedIndex(18)
    } else if (pathname.startsWith('domicile/detaildepense/vehicule')) {
      setSelectedIndex(19)
    } else if (pathname === 'documents') {
      setSelectedIndex(20)
    } else if (pathname.startsWith('mescontacts')) {
      setSelectedIndex(21)
    } else if (pathname === 'social-dashboard') {
      setSelectedIndex(22)
    } else if (pathname === 'moncalendrier') {
      setSelectedIndex(23)
    } else if (pathname.startsWith('bucklist')) {
      setSelectedIndex(24)
    } else if (pathname.startsWith('search')) {
      setSelectedIndex(25)
    } else if (pathname.startsWith('domicile/immovalue/immobilier/')) {
      setSelectedIndex(26)
    } else if (pathname.startsWith('domicile/financement/immobilier/')) {
      setSelectedIndex(27)
    } else if (pathname.startsWith('domicile/detaildepense/immobilier/')) {
      setSelectedIndex(28)
    } else if (pathname === 'dashboard') {
      setSelectedIndex(29)
    } else if (pathname === 'garden') {
      setSelectedIndex(30)
    } else if (pathname === 'domicile/entretien') {
      setSelectedIndex(31)
    } else if (pathname === 'parcourspro') {
      setSelectedIndex(32)
    } else if (pathname === 'todos') {
      setSelectedIndex(33)
    } else if (pathname === 'recette') {
      setSelectedIndex(34)
    } else if (pathname === 'recette-category') {
      setSelectedIndex(35)
    } else if (pathname === 'menu') {
      setSelectedIndex(36)
    } else if (pathname === 'monbudget') {
      setSelectedIndex(37)
    } else if (pathname === 'monpatrimoine') {
      setSelectedIndex(38)
    } else if (pathname === 'synthesetemps') {
      setSelectedIndex(39)
    } else if (pathname === 'opportunities') {
      setSelectedIndex(40)
    } else if (pathname === 'professionnelle') {
      setSelectedIndex(41)
    } else if (pathname === 'tempsdetravail') {
      setSelectedIndex(42)
    } else if (pathname === 'investments') {
      setSelectedIndex(43)
    } else if (pathname === 'roadmap') {
      setSelectedIndex(44)
    }
    setAnchorEl(null)
  }, [location])

  const open = Boolean(anchorEl)
  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const currentPath = location.pathname

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={
          <KeyboardArrowDownRoundedIcon
            sx={{
              transition: 'transform 0.2s ease',
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        }
        sx={{
          textTransform: 'none',
          color: 'white',
          fontWeight: 600,
          fontSize: '0.95rem',
          px: 1.5,
          py: 0.75,
          borderRadius: 2,
          '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
        }}
      >
        {t(options[selectedIndex].tKey)}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
          sx: { py: 0 },
        }}
        PaperProps={{
          elevation: 8,
          sx: {
            mt: 1,
            minWidth: 280,
            maxWidth: 320,
            maxHeight: '70vh',
            borderRadius: 2,
            overflowY: 'auto',
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
          },
        }}
      >
        {/* Header */}
        <Box sx={{ px: 2, py: 1.25 }}>
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
            }}
          >
            {t('nav.lifeApps', { defaultValue: 'Life Apps' })}
          </Typography>
        </Box>
        <Divider />

        {/* Standalone top-level items (Home, etc.) */}
        {menu_main.map((item, key) => (
          <StandaloneItem
            key={`main-${key}`}
            item={item}
            onItemClick={handleClose}
            currentPath={currentPath}
          />
        ))}

        {appMenu.length > 0 && <Divider sx={{ my: 0.5 }} />}

        {/* Grouped sections, each with a translated section title and icon. */}
        {appMenu.map((group, key) => (
          <React.Fragment key={`group-${key}`}>
            <SectionGroup
              group={group}
              onItemClick={handleClose}
              currentPath={currentPath}
            />
            {key < appMenu.length - 1 && <Divider sx={{ mx: 2, my: 0.5 }} />}
          </React.Fragment>
        ))}
      </Menu>
    </div>
  )
}
